module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABaCAYAAAB5XDy9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALJJREFUeNq8jTsOwjAQRMfrQIIAIYpcgYaTcANKrkjDUSg4ARJFChAoPy+ztoIAiRYXTzOe2V3s9roVBbwhEwd0hl5g0AAn6hAEglYkUGlPuCylIfXihAptiOnLwg1pDEa2hRMQ7WyVpw2eqm+HMT+GSmhoi8yC2mCqG6drkNndbE5ca5aLBTFpiOpBTEtibiqWI8432mU1/J1WVOXlo/KF9fE9BVTd7/L/kd7moPlTgAEA55dbsuSPiDsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/9.png
// module id = QmA0
// module chunks = 1